export default {"src":"/_next/static/media/banner-bruno-calonne.3d2990ef.svg","height":48,"width":174,"blurWidth":0,"blurHeight":0};